import React from 'react';
import { Redirect } from 'react-router-dom';
import { AppState } from 'stores/type';
import {
  TypedUseSelectorHook,
  useSelector as useReduxSelector,
} from 'react-redux';
import { AppRoute } from 'views/Router/AppRoute';
import { RouteProps } from 'react-router';
import { DeviceDomain } from 'models/Device';
import { ROUTER_PATH } from 'views/constants';

export const RequiredIphoneUidRoute = (
  props: RouteProps
): React.ReactElement => {
  const useSelector: TypedUseSelectorHook<AppState> = useReduxSelector;
  const device = useSelector((state) => state.deviceState.device);
  const deviceDomain = new DeviceDomain(device);

  return deviceDomain.isInstalledConfigurationProfile() ? (
    <AppRoute {...props} />
  ) : (
    <Redirect to={ROUTER_PATH.configurationProfile} />
  );
};
